import { j as e } from "./jsx-runtime-C5mzlN2N.js";
import { ListTreeIcon as x } from "lucide-react";
import { useRef as l, useState as h, useEffect as f } from "react";
import { c } from "./cn-qaFjX9_3.js";
import { u as v, A as g } from "./Markdown-C5h6bxbE.js";
const d = "data-active", p = ({
  item: s,
  children: r,
  className: n,
  isActive: o
}) => /* @__PURE__ */ e.jsxs("li", { className: c("truncate", n), title: s.value, children: [
  /* @__PURE__ */ e.jsx(
    g,
    {
      to: `#${s.id}`,
      [d]: s.id,
      className: c(
        o ? "text-primary" : "hover:text-accent-foreground text-muted-foreground"
      ),
      children: s.value
    }
  ),
  r
] }), R = ({ entries: s }) => {
  const { activeAnchor: r } = v(), n = l(null), o = l(!1), [u, i] = h({
    top: 0,
    opacity: 0
  });
  return f(() => {
    if (!n.current) return;
    const t = n.current.querySelector(
      `[${d}='${r}']`
    );
    if (!t) {
      i({ top: 0, opacity: 0 });
      return;
    }
    const a = n.current.getBoundingClientRect().top, m = t.getBoundingClientRect().top;
    i({
      opacity: 1,
      top: `${m - a}px`
    }), !o.current && requestIdleCallback(() => {
      o.current = !0;
    });
  }, [r]), /* @__PURE__ */ e.jsxs("aside", { className: "sticky scrollbar top-8 lg:top-[--header-height] h-[calc(100vh-var(--header-height))] pt-[--padding-content-top] pb-[--padding-content-bottom] overflow-y-auto ps-1 text-sm", children: [
    /* @__PURE__ */ e.jsxs("div", { className: "flex items-center gap-2 font-medium mb-2", children: [
      /* @__PURE__ */ e.jsx(x, { size: 16 }),
      "On this page"
    ] }),
    /* @__PURE__ */ e.jsxs("div", { className: "relative ms-2 ps-4", children: [
      /* @__PURE__ */ e.jsx("div", { className: "absolute inset-0 right-auto bg-border w-[2px]" }),
      /* @__PURE__ */ e.jsx(
        "div",
        {
          className: c(
            "absolute -left-px -translate-y-1 h-6 w-[4px] rounded bg-primary",
            o.current && "ease-out [transition:top_150ms,opacity_325ms]"
          ),
          style: u
        }
      ),
      /* @__PURE__ */ e.jsx(
        "ul",
        {
          ref: n,
          className: "relative font-medium list-none space-y-2",
          children: s.map((t) => /* @__PURE__ */ e.jsx(
            p,
            {
              isActive: t.id === r,
              item: t,
              className: "pl-0",
              children: t.children && /* @__PURE__ */ e.jsx("ul", { className: "list-none pl-4 pt-2 space-y-2", children: t.children.map((a) => /* @__PURE__ */ e.jsx(
                p,
                {
                  item: a,
                  isActive: a.id === r
                },
                a.id
              )) })
            },
            t.id
          ))
        }
      )
    ] })
  ] });
};
export {
  R as T
};
//# sourceMappingURL=Toc-BK39DQvI.js.map
